import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import TypographyPoppins from "../../Atoms/TypographyPoppins";
import { sendGTMEvent } from "@next/third-parties/google";
import { BreadcrumbRightArrow } from "../../../public/Theme";
import { CldImage } from "next-cloudinary";

const FlyoutContent = ({ links, headerId, setOpen }) => {
    const [sectionLinks, setSectionLinks] = useState(null);
    return (
        <>
            <div className={`${sectionLinks ? " hidden " : " block "}`}>
                <ul className="flex flex-col gap-5 w-[335px]">
                    {links?.map(({ text, link, flyout_links }, index) => {
                        const key = `top-link-${index}`;
                        return flyout_links?.length ? (
                            <li
                                key={key}
                                className="flex cursor-pointer"
                                onClick={() =>
                                    setSectionLinks({ text, flyout_links })
                                }
                            >
                                <TypographyPoppins
                                    size={"base"}
                                    fontWeight={"light"}
                                    text={text}
                                    customStyle="hover:!underline hover:!font-medium flex-1"
                                />
                                <div className="bg-GRAY_80 rounded-full w-5 h-5 flex justify-center items-center">
                                    <Image
                                        width={10}
                                        height={10}
                                        loading="lazy"
                                        src={BreadcrumbRightArrow}
                                        alt={"Header Icon"}
                                    />
                                </div>
                            </li>
                        ) : (
                            <li key={key}>
                                <Link
                                    href={link || ""}
                                    passHref
                                    id={headerId}
                                    data-cy={headerId}
                                    onClick={() => {
                                        sendGTMEvent({
                                            event: "NavigationInteractions",
                                            menu_name: text,
                                            place: "topnavcollectionmenu",
                                        })
                                        setOpen(false)
                                    }}
                                >
                                    <TypographyPoppins
                                        size={"base"}
                                        fontWeight={"light"}
                                        text={text}
                                        customStyle="hover:!underline hover:!font-medium"
                                    />
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </div>
            <div
                className={`flex flex-row ${sectionLinks ? "block" : "hidden"}`}
            >
                <ul className="flex flex-col gap-3 w-[335px]">
                    {sectionLinks?.flyout_links?.map(
                        ({ link, text }, index) => (
                            <li key={`${link}-${text}-${index}`}>
                                <Link
                                    href={link || ""}
                                    passHref
                                    id={headerId}
                                    data-cy={headerId}
                                    onClick={() => {
                                        sendGTMEvent({
                                            event: "NavigationInteractions",
                                            menu_name: text,
                                            place: "topnavcollectionmenu",
                                        })
                                        setOpen(false)
                                    }}
                                >
                                    <TypographyPoppins
                                        size={"base"}
                                        fontWeight={"light"}
                                        customStyle="hover:!underline hover:!font-medium"
                                        text={text}
                                    />
                                </Link>
                            </li>
                        )
                    )}
                </ul>
                <ul className="mt-3 w-full flex flex-wrap">
                    {sectionLinks?.flyout_links?.map(
                        ({ link, text, src }, index) => (
                            <li
                                key={`${link}-${text}-${index}`}
                                className="my-3 mx-3 group "
                            >
                                <Link
                                    href={link || ""}
                                    passHref
                                    id={headerId}
                                    data-cy={headerId}
                                    onClick={() => {
                                        sendGTMEvent({
                                            event: "NavigationInteractions",
                                            menu_name: text,
                                            place: "topnavcollectionmenu",
                                        })
                                        setOpen(false)
                                    }}
                                >
                                    <div className="relative w-[190px] h-[107px]">
                                        <CldImage
                                            fill
                                            src={src}
                                            alt={`${text} image`}
                                            className="object-cover"
                                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        />
                                    </div>
                                    <TypographyPoppins
                                        size={"base"}
                                        fontWeight={"light"}
                                        customStyle=" mt-2 group-hover:!underline group-hover:!font-medium"
                                        text={text}
                                    />
                                </Link>
                            </li>
                        )
                    )}
                </ul>
            </div>
        </>
    );
};

export default FlyoutContent;
